import cn from "@/v2-ui/utils/utils.cn"
import Button from "@/v2-backoffice-client/components/button"
import { useStaffNotificationsMarkReadMutation } from "@/v2-backoffice-client/notification/markRead/notification.markRead.mutation"

export type NotificationMarkAllReadButtonProps = {
  className?: string
}

function NotificationMarkAllReadButton(
  props: NotificationMarkAllReadButtonProps,
) {
  const { className } = props

  const [markAllRead, { loading }] = useStaffNotificationsMarkReadMutation()

  return (
    <Button
      variant="ghost"
      size="xs"
      iconSrc="check-double"
      isLoading={loading}
      className={cn(
        "notification-mark-all-read-button text-muted-foreground hover:text-foreground",
        className,
      )}
      data-feature-code="UI_BackofficeNotifications_Panel_MarkAllRead"
      onClick={() => {
        // Null ids = every unread row (backoffice.Update_Acc_StaffNotificationsRead).
        markAllRead({ variables: { ids: null } })
      }}
    >
      Mark all read
    </Button>
  )
}

export default NotificationMarkAllReadButton
